import moment from 'moment'
import FormStore from '../../../utils/stores/FormStore'

const initState = {
  dealerId: '',
  equipmentId: '',
  territory: '',
  district: '',
  locality: '',
  addressType: '',
  address: '',
  house: '',
  building: '',
  apartment: '',
  created: '',
  surname: '',
  name: '',
  patronymic: '',
  phone: '',
  preferentialCategory: '',
  senderId: '',
  installed: '',
  categories: [],
  reasonId: '',
}

const validateDataTemplate = {
  dealerId: { required: true },
  equipmentId: { required: true },
  territory: { required: true },
  district: { required: true },
  locality: { required: true },
  address: { required: true },
  surname: { required: true },
  name: { required: true },
  phone: { required: true },
  senderId: { required: true },
  created: {
    required: true,
    validators: [
      (value) => value.length < 16,
      (value) => {
        return (
          !moment(value, 'DD-MM-YYYY, HH:mm').isValid() ||
          moment(value, 'DD-MM-YYYY, HH:mm').isAfter(moment())
        )
      },
    ],
  },
  installed: {
    required: true,
    validators: [
      (value) => value.length < 16,
      (value) => {
        return (
          !moment(value, 'DD-MM-YYYY, HH:mm').isValid() ||
          moment(value, 'DD-MM-YYYY, HH:mm').isAfter(moment())
        )
      },
    ],
  },
}

class AdminAddFormStore extends FormStore {
  constructor() {
    const validateData = { ...validateDataTemplate }
    super({ initState, validateData })
    this.showErrors = true
    this.isValid = false
  }
}

export default AdminAddFormStore
